{
  "salon-details-page": {
    "buttons": {
      "next": "WEITER"
    },
    "meta": {
      "description": "Salon {{salon}} - {{address}} besuchen, Online-Termin 24/7 buchen und tolle Rabatte sichern"
    }
  }
}
